import { render } from "./SensorStats.vue?vue&type=template&id=3bc91c40"
import script from "./SensorStats.vue?vue&type=script&lang=js"
export * from "./SensorStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__